<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<div class="customer-address-page-panel">
		<mat-card class="branding--customer-address-title-card branding--title-card">
			<mat-card-content>
				<h1>{{ customerAddress?.id ? customerAddress?.description : ("CUSTOMER_DETAILS.ADDRESS_DETAILS.TITLE_NEW_ADDRESS_FOR" | translate) + " " + customer?.name }}</h1>
			</mat-card-content>
		</mat-card>
		<mat-card class="branding-customer-address-detail-card branding--section-card">
			<mat-card-content>
				<form [formGroup]="form" class="customer-address-details-form">
					<mat-form-field class="span-3">
						<mat-label>{{ "CUSTOMER_DETAILS.ADDRESS_DETAILS.DESCRIPTION" | translate }}</mat-label>
						<input matInput formControlName="description" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="description"></mat-error>
					</mat-form-field>
					<mat-form-field class="span-2">
						<mat-label>{{ "CUSTOMER_DETAILS.ADDRESS_DETAILS.ADDRESS" | translate }}</mat-label>
						<input matInput formControlName="address" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="address"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.ADDRESS_DETAILS.CITY" | translate }}</mat-label>
						<input matInput formControlName="city" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="city"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.ADDRESS_DETAILS.PROVINCE" | translate }}</mat-label>
						<input matInput formControlName="province" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="province"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.ADDRESS_DETAILS.COUNTRY" | translate }}</mat-label>
						<mat-select [(value)]="Country" [disabled]="isReadOnly()">
							<mat-option *ngFor="let c of countries" [value]="c.code">{{c.label}}</mat-option>
						</mat-select>
						<mat-error [cassErrorForFormControl]="country"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.ADDRESS_DETAILS.ZIPCODE" | translate }}</mat-label>
						<input matInput formControlName="zipcode" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="zipcode"></mat-error>
					</mat-form-field>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card class="branding--action-card button-container">
			<mat-card-content>
				<div class="button-container">
					<button mat-raised-button color="primary" [disabled]="!isValid()" (click)="modifyCustomerAddress()">{{"ACTION_BUTTON_LABELS.SAVE" | translate}}</button>
					<button mat-stroked-button (click)="closeCustomerAddress()">{{"ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate}}</button>
					<button *ngIf="customerAddress?.id" mat-stroked-button (click)='confirmDeleteCustomerAddress()'>{{ "ACTION_BUTTON_LABELS.DELETE" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
